import { v4 as uuidv4 } from "uuid";
import type { newQuotationForm } from "../lib/apis/dtos/request/quotation.request";

/**
 * reference API 로 받아온 다른 업체 시세표를 현재 편집 폼에 합친다.
 * - 현재 폼의 메타(storeId, storeName, 활성/기간, version 등)는 유지
 * - 편집 화면의 행 key 가 uuid 이므로 lows/kids/dps 에 uuid 재부여
 * 제출은 하지 않는다 — 폼 state 에만 채운다.
 */
export const mergeImportedQuotation = (source: newQuotationForm, target: newQuotationForm): newQuotationForm => ({
  ...target,
  ...source,
  quotationId: target.quotationId,
  storeId: target.storeId,
  storeName: target.storeName,
  storeAreaName: target.storeAreaName,
  zoneId: target.zoneId,
  isActive: target.isActive,
  startDate: target.startDate,
  endDate: target.endDate,
  version: target.version,
  createAt: target.createAt,
  publisherName: target.publisherName,
  normals: source.normals ?? [],
  lows: (source.lows ?? []).map((item) => ({ ...item, uuid: uuidv4() })),
  kids: (source.kids ?? []).map((item) => ({ ...item, uuid: uuidv4() })),
  dps: (source.dps ?? []).map((item) => ({ ...item, uuid: uuidv4() })),
  usims: source.usims ?? [],
  additionalServices: source.additionalServices ?? [],
});
